import React from 'react';
import './App.css';
import CustomNavbar from './components/CustomNavBar'
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import watch1 from './Images/GarminWatchApp.png';
import watch1_thumb from './Images/GarminWatchApp_thumb.png';
import ImageGallery from 'react-image-gallery';
import logo from './Images/TrueNorth_garmin.png';
import CustomBtn from './components/CustomButton'
import  { FirebaseContext } from "./components/Firebase";
import Button from '@material-ui/core/Button';
import MLink from '@material-ui/core/Link';
import { Route, Link, BrowserRouter as Router } from 'react-router-dom';
//import "react-image-gallery/styles/css/image-gallery.css";
import './ImageGallery.css';
import { textAlign } from '@material-ui/system';

//function App() {

class TrueNorthDownloads extends React.Component {


render() {

  const boxStyle = { 
    width: 'fit-content', 
    background:'rgba(248, 248, 248, 0.6)', 
    borderRadius:'5px', 
    padding:'15px', 
    margin: '5px',
    minHeight: '500px',
    minWidth: '400px',
    boxShadow:'0 8px 12px 0 rgba(0, 0, 0, 0.24), 0 6px 20px 0 rgba(0, 0, 0, 0.18)'
  };

  const images = [
    {
      original: watch1,
      thumbnail: watch1_thumb,
    },
  ]

  return (
    <div style={{height:'100%'}}>
    <div style={{minHeight:'92vh'}}>
    <CustomNavbar logo={true}></CustomNavbar>

    <Grid container direction="column" justify={'center'} alignItems={'center'} style={{marginLeft:'-10px' ,paddingTop:'30px'}}>
      <Typography variant="h5" style={{ marginBottom:'30px', color:'black', maxWidth:"80%", padding:'0px 35px 3px 35px', borderBottom: '1px solid #8d8c8c'}}>
         Downloads
      </Typography>  

      <MLink href={"https://firebasestorage.googleapis.com/v0/b/truenorth-243117.appspot.com/o/truenorth%20Setup%201.0.2.exe?alt=media&token=d9af93de-84d9-4b9c-bfda-5394529ce668"} color="primary">
            <Button color="primary" style={{padding:'8px'}}>TrueNorth Server v1.0.2 ( windows 64bit )</Button>
      </MLink>

      <MLink href={"https://firebasestorage.googleapis.com/v0/b/truenorth-243117.appspot.com/o/TrueNorth%20Server%20Manual.pdf?alt=media&token=514ec44a-dfa3-463c-9afc-d90aad5e7795"} color="primary">
            <Button color="primary" style={{padding:'8px'}}>TrueNorth Server Manual</Button>
      </MLink>

      <MLink href={"https://apps.garmin.com/en-US/apps/03b72dca-de16-48a0-a878-2531f229b8c7"} color="primary">
            <Button color="primary" style={{padding:'8px'}}>TrueNorth Garmin App</Button>
      </MLink>
    </Grid>
    </div>

    <div style={{minHeight:'8vh', boxShadow:'0 0px 12px 0 rgba(0, 0, 0, 0.4), 0 0px 20px 0 rgba(0, 0, 0, 0.4)', backgroundColor:'#313131'}}>
    <Grid container direction="row" justify={'center'} alignItems={'center'} style={{height:'8vh'}}>
    <Typography variant="body2" style={{color:'white', textAlign: 'center'}}>
                  Contact us at truenorthsailingsoftware@gmail.com | +27-84-600-6091
    </Typography>
    </Grid>
    </div> 


    </div>
    );
  }
}

export default TrueNorthDownloads;
